<template>
  <div class="how-it-works">
    <section class="section1 container">
      <p class="title">
        The Advanced Technology Behind Understanding Your Emotions
      </p>
      <p class="details">
        Your heart holds the truth about your emotions. But it takes a special
        kind of technology and formula to truly decode them,
      </p>
      <p class="details">
        Upmood Watch uses a revolutionary method to measure biometric patterns
        of the heart to track, monitor and quantify your emotions.
      </p>
      <img src="@/assets/img/Screen Shot 2021-01-22 at 6.18.30 PM@2x.png" />
    </section>

    <section class="section2 container">
      <div class="top-wrapper">
        <div class="image-wrapper">
          <img src="@/assets/img/scientist1@2x.png" class="boy" />
          <img src="@/assets/img/scientist 2@2x.png" class="girl" />
        </div>
        <div class="details-wrapper">
          <p class="details">
            The advanced biometric technology behind Upmood is based on more
            than four years of expert research by professors Thomas K.S WONG and
            Joanne Way Yee CHUNG from University of Hong Kong.
          </p>
        </div>
      </div>
      <div class="bot-wrapper">
        <p class="details">
          Our research team has collected thousands of human data points via
          multiple standardized emotion simulations on almost 1000 people to
          reveal the hidden links between your emotions and heart function.
        </p>
        <p class="details">
          Using this unmatched data and understanding of your body’s emotions,
          Upmood Watch uses a revolutionary method to measure the biometric
          patterns of your heart to track, monitor and quantify your emotions.
        </p>
      </div>
    </section>

    <section class="section3 container">
      <p class="title">Collecting your bio data</p>
      <div class="image-wrapper">
        <!-- <img src="@/assets/img/Screen Shot 2020-10-26 at 3.39.48 PM.png" /> -->
        <lottie-player
          src="https://assets3.lottiefiles.com/private_files/lf30_jp5nrbsu.json"
          background="transparent"
          speed="1"
          style="width: 500px; height: 500px;"
          loop
          autoplay
        >
        </lottie-player>
        <div class="details-wrapper">
          <p class="details">
            First, Upmood Watch measures the function of your heart by gathering
            P-P interval (PPI) measurements via an advanced PPG
            (photoplethysmogram) sensor that precisely gathers electrical
            activities of the heart through your veins.
          </p>

          <p class="details">
            The PPG sensor uses a light source that detects blood circulation
            volume variations through the surface of the skin.
          </p>
        </div>
      </div>
    </section>

    <section class="section4 container">
      <div class="details-wrapper">
        <p class="details">
          PPIs are calculated using the HRV (Heart Rate Variability) calculator
          with the help of R-R interval data - another marker of heart function.
        </p>
        <p class="second-details">
          This heart rhythm data is then sent to the Upmood App via Bluetooth.
        </p>
      </div>
      <div class="image-wrapper">
        <img src="@/assets/img/Group 132.png" />
      </div>
    </section>

    <section class="section5 container">
      <p class="title">Interpreting Your Biodata</p>
      <div class="details-wrapper">
        <img src="@/assets/img/Upmood Illustration_2_x1.png" class="diagram" />
        <p class="details">
          The Upmood App uses an advanced, scientifically-designed formula to
          accurately evaluate the HRV data and interprets it as emotions such as
          sadness, joy, and neutral.
        </p>
      </div>
      <div class="details-wrapper">
        <p class="details">
          In addition, Upmood App doesn’t just look at this data in isolation.
          Emotional result is categorized and calculated based on previous
          emotions, current emotion data, past stress and current stress levels
          and heart rate.
        </p>
        <img src="@/assets/img/Upmood_Illustration_1_x1.png" class="emoji" />
      </div>
    </section>

    <section class="section6 container">
      <p class="title">Emotion layout diagram</p>
      <img src="@/assets/img/Emotional diagram-01.png" class="level1" />
      <img src="@/assets/img/Emotional diagram-02.png" class="level2" />
    </section>

    <section class="section7 container">
      <p class="title">Delivering a Clear Picture of Your Emotions</p>
      <span class="first">
        The end result is the most detailed reading and understanding of your
        emotions ever created.
      </span>
      <span class="second">
        And when you know yourself at this emotional level,
      </span>
      <span class="third">
        you have all the tools for understanding emotional well-being.
      </span>
      <img src="@/assets/img/phone.png" />
    </section>

    <section class="section8" :style="`background-image: url('${bgImg}')`">
      <p class="title">We’re on a Mission to Deepen Human Connections</p>
      <router-link to="/ContactUs" tag="button" class="button-cyan"
        >Collaborate with us</router-link
      >
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: require(`@/assets/img/Connection.png`)
    };
  }
};
</script>

<style lang="scss" scoped>
.how-it-works {
  padding-top: 160px;
  font-family: $Lato;

  @include mobile {
    width: 100%;
  }

  .container {
    padding-left: 150px;

    @include mobile {
      padding: 0px 15px;
    }
  }

  .section1 {
    display: flex;
    flex-direction: column;
    margin-top: 100px;

    .title {
      font-family: $Lato;
      color: #362d2d;
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 75px;

      @include mobile {
        text-align: center;
      }
    }

    .details {
      color: #707070;
      font-size: 21px;
      margin-bottom: 35px;
    }

    img {
      width: 100%;
    }
  }

  .section2 {
    margin-top: 150px;

    .top-wrapper {
      display: flex;
      align-items: center;
      margin-bottom: 100px;

      @include mobile {
        flex-direction: column;
        margin-bottom: 30px;
      }

      .image-wrapper {
        display: flex;
        flex-direction: column;

        @include mobile {
          margin-bottom: 30px;
        }

        .boy {
          margin: 0px 150px 75px 0px;
        }

        .girl {
          margin-left: 150px;
        }
      }

      .details-wrapper {
        .details {
          font-size: 21px;
          color: #707070;
          line-height: 27px;
        }
      }
    }

    .bot-wrapper {
      .details {
        color: #707070;
        font-size: 21px;
        margin-bottom: 30px;
      }
    }
  }

  .section3 {
    margin-top: 220px;

    .title {
      color: #362d2d;
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 65px;

      @include mobile {
        text-align: center;
      }
    }

    .image-wrapper {
      display: flex;

      @include mobile {
        flex-direction: column;
      }

      .details-wrapper {
        display: flex;
        flex-direction: column;
        // padding-left: 70px;

        @include mobile {
          padding: 30px 0px 0px 0px;
        }

        .details {
          color: #707070;
          font-size: 21px;
          line-height: 32px;

          &:first-child {
            margin-bottom: 20px;
          }
        }
      }
    }
  }

  .section4 {
    padding-top: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .details-wrapper {
      width: 720px;
      text-align: center;

      @include mobile {
        width: 100%;
      }

      p {
        color: #707070;
        font-size: 21px;
        line-height: 26px;

        &.second-details {
          margin-bottom: 95px;
        }
      }
    }

    .image-wrapper {
      display: flex;
      align-items: center;

      img {
        width: 100%;
      }
    }
  }

  .section5 {
    padding-top: 320px;

    .title {
      color: #362d2d;
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 115px;

      @include mobile {
        text-align: center;
      }
    }

    .details-wrapper {
      display: flex;
      align-items: center;
      margin-bottom: 200px;

      @include mobile {
        flex-direction: column;
        margin-bottom: 100px;
      }

      &:last-child {
        @include mobile {
          flex-direction: column-reverse;
        }
      }

      .details {
        font-size: 21px;
        color: #707070;
        line-height: 26px;

        @include mobile {
          text-align: center;
        }
      }

      .diagram {
        margin-right: 40px;

        @include mobile {
          margin: 0px 0px 30px 0px;
        }
      }

      .emoji {
        margin-left: 40px;

        @include mobile {
          margin: 0px 0px 30px 0px;
        }
      }
    }
  }

  .section6 {
    padding-top: 180px;
    display: flex;
    flex-direction: column;
    text-align: center;

    .title {
      color: #362d2d;
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 50px;
    }

    .level1 {
      margin-bottom: 60px;
    }

    img {
      width: 100%;
    }
  }

  .section7 {
    padding-top: 300px;
    text-align: center;
    .title {
      color: #362d2d;
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 27px;
    }

    span {
      color: #6b7a80;
      font-size: 21px;
      display: block;

      &.first {
        width: 790px;
        margin: auto;

        @include mobile {
          width: 100%;
          margin-bottom: 15px;
        }
      }

      &.third {
        margin-bottom: 70px;
      }
    }

    img {
      height: 520px;
    }
  }

  .section8 {
    margin-top: 210px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-size: cover;
    background-repeat: no-repeat;
    height: 720px;

    .title {
      color: #fff;
      font-size: 35px;
      font-weight: 700;
      margin-bottom: 40px;

      @include mobile {
        text-align: center;
      }
    }
  }
}
</style>
